export const LEGALRUMIJA_LOADING = "LEGALRUMIJA_LOADING";
export const LEGALRUMIJA_RESET = "LEGALRUMIJA_RESET";
export const GET_LEGALRUMIJA = "GET_LEGALRUMIJA";
export const GET_LEGALRUMIJA_SUCCESS = "GET_LEGALRUMIJA_SUCCESS";
export const GET_LEGALRUMIJA_FAIL = "GET_LEGALRUMIJA_FAIL";
export const DELETE_LEGALRUMIJA = "DELETE_LEGALRUMIJA"
export const DELETE_LEGALRUMIJA_SUCCESS = "DELETE_LEGALRUMIJA_SUCCESS"
export const DELETE_LEGALRUMIJA_FAIL = "DELETE_LEGALRUMIJA_FAIL"
export const UPDATE_LEGALRUMIJA = "UPDATE_LEGALRUMIJA"
export const UPDATE_LEGALRUMIJA_SUCCESS = "UPDATE_LEGALRUMIJA_SUCCESS"
export const UPDATE_LEGALRUMIJA_FAIL = "UPDATE_LEGALRUMIJA_FAIL"
export const ADD_NEW_LEGALRUMIJA = "ADD_NEW_LEGALRUMIJA"
export const ADD_LEGALRUMIJA_SUCCESS = "ADD_LEGALRUMIJA_SUCCESS"
export const ADD_LEGALRUMIJA_FAIL = "ADD_LEGALRUMIJA_FAIL"